import Image, { StaticImageData } from "next/image"
import { useLanguage } from "@/utils/LanguageContext"

import founder_thumb_1 from "@/assets/img/update/team/founder-1-1.png"
import founder_thumb_2 from "@/assets/img/update/team/founder-1-2.png"

interface DataType {
   id: number;
   thumb: StaticImageData;
   title: string;
   designasion: string;
   bio?: string;
   linkedin?: string;
   bookUrl?: string;
}

const founder_data: DataType[] = [
   {
      id: 1,
      thumb: founder_thumb_1,
      title: "Malek Almsaddi",
      designasion: "Co-Founder & CEO",
      bio: "bio_malek_almsaddi",
      linkedin: "https://www.linkedin.com/in/malekalmsaddi/",
      bookUrl: "https://learndefi.online",
   },
   {
      id: 2,
      thumb: founder_thumb_2,
      title: "Mario G Figlioli",
      designasion: "Co-Founder & CCO",
      bio: "bio_mario_figlioli",
      linkedin: "https://www.linkedin.com/in/mario-giovanni-figlioli-9bb5661a9/",
   },
]

const TeamFounder = () => {
   const { t } = useLanguage();
   return (
      <section className="pb-110 home-anchor-subtarget" id="team-founders" aria-labelledby="founders-title">
         <div className="container">
            <div className="section-title text-center mb-50">
               <h2 className="title style2" id="founders-title">{t("Founders")}</h2>
            </div>
            <div className="row gy-4 justify-content-center">
               {founder_data.map((item) => (
                  <div key={item.id} className="col-lg-6 d-flex">
                     <div className="founder-card h-100">
                        <div className="founder-card-img">
                           <Image src={item.thumb} alt={item.title} loading="lazy" />
                        </div>
                        <div className="founder-card-details">
                           <h3 className="founder-card-title">{item.title}</h3>
                           <p className="founder-card-desig">{item.designasion}</p>
                           {item.bio && (
                              <p className="founder-card-bio">{t(item.bio)}</p>
                           )}
                           <div className="social-btn">
                              <a
                                 href={item.linkedin ?? "https://www.linkedin.com/"}
                                 target="_blank"
                                 rel="noopener noreferrer"
                                 aria-label="LinkedIn"
                              >
                                 <i className="fab fa-linkedin"></i>
                              </a>
                              {item.bookUrl && (
                                 <a
                                    href={item.bookUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Learn DeFi"
                                 >
                                    <i className="fas fa-book"></i>
                                 </a>
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   )
}

export default TeamFounder
